package com.pincer.core.model.tree

import kotlinx.serialization.Serializable
import kotlin.js.JsName

@Serializable
data class Participant

(

    @JsName("name")       var name       : String? = null,
    @JsName("roles")      var roles      : String = "",
    @JsName("zone")       var zone       : String = "US/Eastern",
    @JsName("locale")     var locale     : String = "en-US",
    @JsName("redRules")   var redRules   : String = "",
    @JsName("greenRules") var greenRules : String = "",
    @JsName("stencil")    var stencil    : Boolean = false,
    @JsName("answers")    var answers    : MutableMap<String,Answer> = mutableMapOf<String,Answer>(),

)

{

    fun duplicate(includeRules:Boolean, includeAnswers: Boolean): Participant {
        val useRedRules   = if (includeRules) redRules   else "REDACTED"
        val useGreenRules = if (includeRules) greenRules else "REDACTED"
        val build = Participant(name = name, roles = roles, zone = zone, locale = locale, redRules = useRedRules, greenRules = useGreenRules, stencil = stencil)
        if (includeAnswers) {
            answers.forEach({ entry ->
                build.answers[entry.key] = entry.value.duplicate()
            })
        }
        return build
    }

    fun isInRole(role: String): Boolean = ",$roles,".contains(",$role,")

    fun addRole(role: String) {
        if (roles.isNotEmpty()) roles = roles + ","
        roles = roles + role
    }

}
